import { connect } from 'react-redux';

import { IAppState } from 'src/store';
import { Button, Text, View } from 'src/components/common';
import { ReactNode } from 'react';

type ModalVariantType = 'danger' | 'success' | 'primary' | 'secondary';

export type YesNoModalData = {
  title: string;
  message: ReactNode;
  okText?: string;
  cancelText?: string;
  onCancel?: (...arg: any[]) => void;
  onOk?: (...arg: any[]) => void;
  variant?: ModalVariantType;
};

const YesNoModal: React.FC<Props> = ({ modalData }) => {
  const {
    title,
    message,
    okText,
    cancelText,
    variant = 'primary',
    onOk = () => {},
    onCancel = () => {},
  } = modalData as YesNoModalData;

  return (
    <View className={`cmp-yes-no-modal-variant`}>
      <Text className="mb-24" size={20}>
        {title}
      </Text>
      {message && <Text className="mb-5 ctn-modal__content__message">{message}</Text>}
      <View isRow justify="flex-end">
        <Button className="mr-16 is-uppercase" variant="secondary-outline" onClick={onCancel}>
          {cancelText || 'CANCEL'}
        </Button>
        <Button className="is-uppercase" variant={variant} onClick={onOk}>
          {okText || 'OK'}
        </Button>
      </View>
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps & {};

const mapStateToProps = (state: IAppState) => ({
  modalData: state.modal.data,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(YesNoModal);
